import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

import Particle from '../Particle'
import {
  AiFillTwitterCircle,
  AiFillLinkedin,
  AiFillGithub,
} from 'react-icons/ai'
import { SiHashnode } from 'react-icons/si'
import { Link } from 'react-router-dom'
import { Form } from './Form'

function Contact() {
  return (
    <Container fluid className="project-section">
      {/* <Particle /> */}

      <Container>
        <h1 className="project-heading">
          Get In <strong className="purple">Touch</strong>
        </h1>
        <p style={{ color: 'white' }}>
          Here are a few projects I've worked on recently.
        </p>
      </Container>

      <Form />
    </Container>
  )
}

export default Contact
